import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider, useTranslation } from "react-i18next";
import { AppRoutes } from "./router";
import i18n, { applyDocumentDirection } from "./i18n";
import { AuthProvider } from "./context/AuthContext";

function DirectionSync() {
  const { i18n: instance } = useTranslation();

  useEffect(() => {
    applyDocumentDirection(instance.language);
  }, [instance.language]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <DirectionSync />
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;